function createForm() {
  const form = document.createElement('form')
  const input = document.createElement('input')
  input.type = 'file'

  form.style.display = 'none'

  form.append(input)
  document.body.append(form)
  return form
}

export const fileSelector = (function () {
  let form = createForm()
  return function select(
    cb,
    { accept, multiple } = { accept: '*', multiple: false }
  ) {
    // 如果form被不正常移除
    if (form.parentNode !== document.body) {
      try {
        form.reset()
        form.children[0].remove()
        form.remove()
      } catch (_) {}
      form = createForm()
    }
    const input = form.children[0]
    input.accept = accept
    input.multiple = multiple
    input.click()
    input.onchange = async () => {
      try {
        await cb(input.files)
      } catch (_) {
      } finally {
        form.reset()
      }
    }

    input.onabort = input.onclose = input.onblur = console.error
  }
})()
